export const mapBackendOrderToFrontend = (backendOrder) => {
    // Handle both snake_case and camelCase responses
    const shippingAddress = backendOrder.shippingAddress || backendOrder.shipping_address || {};
    const contactPhone = backendOrder.contactPhone || backendOrder.contact_phone || {};
    const shippingMethod = backendOrder.shippingMethod || backendOrder.shipping_method || {};
    const salesRepDetail = backendOrder.salesRepDetail || backendOrder.sales_rep_detail;
    return {
        id: backendOrder.id ? parseInt(backendOrder.id.replace(/-/g, '').substring(0, 8), 16) : 0,
        uuid: backendOrder.id,
        order_number: backendOrder.orderNumber || backendOrder.order_number || '',
        clinic: backendOrder.clinic
            ? (typeof backendOrder.clinic === 'string' ? parseInt(backendOrder.clinic.replace(/-/g, '').substring(0, 8), 16) : backendOrder.clinic)
            : 0,
        clinic_name: backendOrder.clinicName || backendOrder.clinic_name || backendOrder.clinic_detail?.name,
        shipping_address: {
            street: (shippingAddress.street1 || shippingAddress.street_1 || '') +
                ((shippingAddress.street2 || shippingAddress.street_2) ? ` ${shippingAddress.street2 || shippingAddress.street_2}` : ''),
            city: shippingAddress.city || '',
            state: shippingAddress.state || '',
            zip: shippingAddress.postalCode || shippingAddress.postal_code || '',
        },
        shipping_method: shippingMethod.name || backendOrder.shipping_method || '',
        contact_email: backendOrder.contactEmail || backendOrder.contact_email || '',
        contact_phone: typeof contactPhone === 'string'
            ? contactPhone
            : contactPhone.formattedNumber || contactPhone.formatted_number || contactPhone.number || '',
        subtotal: backendOrder.subtotal || '0.00',
        shipping_estimated_days: shippingMethod.estimatedDays || shippingMethod.estimated_days || 0,
        shipping_cost: backendOrder.shippingCost || backendOrder.shipping_cost || '0.00',
        tax_amount: backendOrder.taxAmount || backendOrder.tax_amount || '0.00',
        total: backendOrder.total || '0.00',
        promo_code: backendOrder.promoCodeDetail?.code || backendOrder.promo_code_detail?.code || backendOrder.promoCode || backendOrder.promo_code,
        promo_discount: backendOrder.promoDiscount || backendOrder.promo_discount || '0.00',
        status: backendOrder.status || 'pending',
        notes: backendOrder.notes || '',
        payment_type: (backendOrder.paymentType || backendOrder.payment_type) || 'credit_card',
        payment_status: (backendOrder.paymentStatus || backendOrder.payment_status) || 'pending',
        payment_transaction_id: backendOrder.paymentTransactionId || backendOrder.payment_transaction_id,
        payment_processed_at: backendOrder.paymentProcessedAt || backendOrder.payment_processed_at,
        payment_error_message: backendOrder.paymentErrorMessage || backendOrder.payment_error_message,
        created_at: backendOrder.createdAt || backendOrder.created_at || new Date().toISOString(),
        updated_at: backendOrder.updatedAt || backendOrder.updated_at || new Date().toISOString(),
        tracking_number: backendOrder.trackingNumber || backendOrder.tracking_number,
        sales_rep_id: salesRepDetail?.salesRepId || salesRepDetail?.sales_rep_id || null,
        sales_rep_name: salesRepDetail?.name || null,
        territory_id: backendOrder.territoryId || backendOrder.territory_id || null,
    };
};
export const mapBackendOrdersToFrontend = (backendOrders) => {
    return backendOrders.map(mapBackendOrderToFrontend);
};
export const mapBackendOrderItemToFrontend = (backendItem) => {
    return {
        id: backendItem.id,
        order: backendItem.order,
        product: backendItem.product,
        product_name: backendItem.productName || backendItem.product_name || '',
        sku: backendItem.sku || '',
        quantity: backendItem.quantity || 0,
        unit_price: backendItem.unitPrice || backendItem.unit_price || '0.00',
        total_price: backendItem.totalPrice || backendItem.total_price || '0.00',
    };
};
